var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',[_c('form-controls-list',{attrs:{"form":_vm.form,"config":_vm.config}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }